import { useCallback, useEffect, useMemo, useState } from 'react';

export default function useContractAcceptance({ linkData, validation, requiresCustomerInfo, showCustomerForm }) {
    const [showContract, setShowContract] = useState(false);
    const [contractAccepted, setContractAccepted] = useState(false);
    const [hasReadContract, setHasReadContract] = useState(false);
    const [contractData, setContractData] = useState({ debtorName: null, debtorEmail: null, amountTL: null, invoiceCompanyName: null });

    const snapshotCurrent = useCallback(() => {
        const debtorName = requiresCustomerInfo
            ? validation.values.customer_name
            : (linkData?.accountName || validation.values.customer_name || validation.values.cc_owner || 'Müşteri');

        const debtorEmail = showCustomerForm ? validation.values.customer_email : linkData?.invoiceEmail;

        const amountTL = parseFloat(validation.values.amount);

        let invoiceCompanyName = linkData?.invoiceCompanyName || debtorName;
        if (showCustomerForm && requiresCustomerInfo) {
            invoiceCompanyName = validation.values.companyName || validation.values.customer_name || debtorName;
        }
        return {
            debtorName,
            debtorEmail,
            amountTL: Number((amountTL || 0).toFixed(2)),
            invoiceCompanyName
        };
    }, [validation.values, requiresCustomerInfo, showCustomerForm, linkData?.accountName, linkData?.invoiceEmail, linkData?.invoiceCompanyName]);

    const handleAcceptContract = useCallback(() => {
        const snap = snapshotCurrent();
        setContractData(snap);
        setContractAccepted(true);
        setShowContract(false);
    }, [snapshotCurrent]);

    useEffect(() => {
        if (!contractAccepted) return;
        const current = snapshotCurrent();
        const changed =
            current.debtorName !== contractData.debtorName ||
            current.debtorEmail !== contractData.debtorEmail ||
            current.amountTL !== contractData.amountTL ||
            current.invoiceCompanyName !== contractData.invoiceCompanyName;

        if (changed) {
            setContractAccepted(false);
        }
    }, [contractAccepted, snapshotCurrent, contractData]);

    const canSubmitWithContract = useMemo(() => contractAccepted, [contractAccepted]);

    return {
        showContract, setShowContract,
        contractAccepted, setContractAccepted,
        hasReadContract, setHasReadContract,
        contractData,
        handleAcceptContract,
        canSubmitWithContract
    };
}